
const findClosest = (arr, goal) => {
    return arr.reduce(function(prev, curr) {
        return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
  });
}

export default findClosest